import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAnswer } from '../interfaces/answer.interface';
import { QuizContent } from '../interfaces/quiz-content.interface';
import { IContentState } from '../interfaces/content-state.interface';

const contentState: IContentState = {
  currentContent: {
    bonuses: [],
    questions: [],
    footer: "",
    header: {},
    finalForm: {
      header: "Последний шаг! Оставьте ваш телефон и мы свяжемся с вами",
      buttonText: "Получить"
    }
  },
  initialContent: {},
  expertComment: ""
}

export const contentSlice = createSlice({
  name: "content",
  initialState: contentState,
  reducers: {
    setCurrentContent: (state, action: PayloadAction<QuizContent>) => {
      state.currentContent = { ...state.currentContent, ...action.payload};
    },

    setInitialContent: (state, action: PayloadAction<QuizContent>) => {
      state.initialContent = action.payload;
    },

    resetCurrentContent: (state) => {
      const questions = state.currentContent.questions;
      state.currentContent = state.initialContent;
      state.currentContent.questions = questions;
    },

    updateCurrentContent: (state, action: PayloadAction<Partial<QuizContent>>) => {
      const distributorQuestionIndex = state.initialContent?.questions.findIndex(question => question.distributor);
      const currentContent = state.currentContent;

      const updatedCurrentContent = {
        ...currentContent,
        ...action.payload,
        questions: [
          ...currentContent.questions.filter((_, index) => index <= distributorQuestionIndex),
          ...action.payload.questions
        ],
        header: {
          ...currentContent.header,
          ...action.payload.header
        },
        finalForm: {
          ...currentContent.finalForm,
          ...action.payload.finalForm
        },
        finalPage: {
          ...currentContent.finalPage,
          ...action.payload.finalPage
        },
        expert: {
          ...currentContent.expert,
          ...action.payload.expert
        },
        bonuses: action.payload.bonuses || currentContent.bonuses
      };

      state.currentContent = updatedCurrentContent;
    },
  
    checkAnswer: (state, action) => {
      const target = action.payload;

      const { answers, multiple } = state.currentContent.questions.find((q) => q.id == target.questionId) || {};

      answers?.forEach((answer: IAnswer) => {
        if (answer.value == target.value) answer.checked = target.checked;
        else if ((target.checked && mutuallyExclusive(target, answer)) || !multiple) {
          answer.checked = false;
        }
      });
    },
  
    replaceHeaderPhone: (state, action: PayloadAction<string>) => {
      state.currentContent.header.phone = action.payload;
    },

    setExpertsComment: (state, action: PayloadAction<string>) => {
      state.expertComment = action.payload;
    }
  }
})

function mutuallyExclusive(answ1: any, answ2: any) {
  return (answ1.reset && !answ2.reset) || (!answ1.reset && answ2.reset);
}
 
export const { setCurrentContent, setInitialContent, checkAnswer, replaceHeaderPhone, updateCurrentContent, resetCurrentContent, setExpertsComment } = contentSlice.actions;
export default contentSlice.reducer;